import Bar from "./Bar";
import Circle from "./Circle";

export type { BarProps } from "./Bar";
export type { CircleProps } from "./Circle";

const Progress = {
  Bar,
  Circle,
};

export default Progress;

// 개별 import 지원
export { Bar, Circle };
